import { useTranslation } from 'react-i18next';
import { NavigateFunction } from 'react-router-dom';
import useRTOListData from './useRTOListData';
import { getRTOColumns } from '@/pages/pickups/rtoList.tsx';
import { useOpenEntityTicketModal } from './useOpenEntityTicketModal';
import { TicketEntityIDFieldEnum } from '@/constants';
import usePermission from './usePermission';

/**
 * Custom hook to manage RTO tab data and columns
 * @param current Current page number
 * @param pageSize Size of each page
 * @param enabled Whether the tab is currently active
 * @param search Optional search query string
 */
const useRTOTab = (current: number, pageSize: number, enabled = true, search?: string) => {
  const { hasPermission } = usePermission();
  const { dataRTO, totals, isFetching } = useRTOListData(current, pageSize, enabled, search);
  const { openEntityTicketModal } = useOpenEntityTicketModal(TicketEntityIDFieldEnum.PICKUP);

  // Get columns for RTO tab
  const columns = getRTOColumns(openEntityTicketModal, hasPermission);

  return {
    data: dataRTO,
    totals,
    isFetching,
    columns,
  };
};

export default useRTOTab;
